import { render, staticRenderFns } from "./moments.vue?vue&type=template&id=c9c4114e&scoped=true"
import script from "./moments.vue?vue&type=script&lang=js"
export * from "./moments.vue?vue&type=script&lang=js"
import style0 from "./moments.vue?vue&type=style&index=0&id=c9c4114e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c4114e",
  null
  
)

export default component.exports